import React from 'react';
import Modal from 'react-modal';
import './SolutionModal.css'
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const SolutionModal = (props: any) => {
    const modalClassName = props.isOpen ? 'solutionModal active' : 'solutionModal';
    const {i18n, t} = useTranslation();
    
    const [tracksModal, setTracksModal] = useState<string[]>()

    interface Champion {
        id: number;
        name: string;
        positions: string[];
        region: string[];
        species: string[];
        releaseYear: string[];
        src: string;
    }

    useEffect(() => {
        if(props.tracks) {
            setTracksModal([props.tracks[0].charAt(0).toUpperCase()+props.tracks[0].slice(1), props.tracks[1].charAt(0).toUpperCase()+props.tracks[1].slice(1), props.tracks[2].charAt(0).toUpperCase()+props.tracks[2].slice(1)])
        }

    }, [props.tracks])

    return (
    <Modal
        isOpen={props.isOpen}
        onRequestClose={props.onClose}
        contentLabel="Solution Modal"
        ariaHideApp={false}
        className={modalClassName}
    >
        <div className='solution'>
            <button onClick={props.onClose} className="close-button">×</button>
            <h1 className='tracks'>{tracksModal ? tracksModal[0] + " & " + tracksModal[1] + " & " + tracksModal[2]: ""} </h1>
            <h1 style={{ marginBottom: "20px" }}>
                {props.championsSolution && props.championsSolution.length ? (
                    <>{props.championsSolution.length} {props.championsSolution.length === 1 ? t('modal-solution.subTitleSin') : t('modal-solution.subTitlePl')}</>
                ) : null}
            </h1>
            <div className='champions-container'>
                    {props.championsSolution
                        ? props.championsSolution.map((champ: Champion) => (
                            <div key={champ.id+"div"} className='champion-solution'>
                                <img className='img-champion-solution' src={champ.src} alt="Image champion square solution" ></img>
                                <span key={champ.id}>{champ.name.toUpperCase()}</span>
                            </div>
                        ))
                    : null}
            </div>
        </div>
    </Modal>
  );
};